import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CurrentOrganizationLogoComponent } from "./current-organization-logo.component";
import { LHSMiproLogoComponent } from "./lhs-mipro-logo.component";
import { BrandingService } from "./branding.service";

@NgModule({
    declarations: [
        LHSMiproLogoComponent,
        CurrentOrganizationLogoComponent
    ],
    imports: [
        CommonModule        
    ],
    exports: [LHSMiproLogoComponent, CurrentOrganizationLogoComponent],
    providers: [BrandingService],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BrandingModule {}